import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { WhitelistAddressStepType } from 'data/Form/WhitelistAddress/types'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import Whitelist from './template'

export type PropsType = ConnectedProps<typeof connector>

class WhitelistAddressContainer extends React.Component<PropsType> {
  componentWillUnmount() {
    this.props.removeTotpConfig()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.handleSubmit(this.props.step)
  }

  handleStepChange = (step: WhitelistAddressStepType) => {
    this.props.resetForm()
    this.props.goToStep(step)
  }

  render() {
    const {
      email,
      hideModal,
      initialValues,
      isLoading,
      isWhitelistingEnabled,
      removeTotpConfig,
      resetForm,
      step
    } = this.props

    return (
      <Whitelist
        email={email}
        goToStep={this.handleStepChange}
        handleSubmit={this.handleSubmit}
        hideModal={hideModal}
        initialValues={initialValues}
        isLoading={isLoading}
        isWhitelistingEnabled={isWhitelistingEnabled}
        removeTotpConfig={removeTotpConfig}
        resetForm={resetForm}
        step={step}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  email: selectors.auth.getEmail(state),
  initialValues: selectors.whitelistAddress.getInitialValues(state),
  isLoading: selectors.whitelistAddress.isLoading(state),
  isWhitelistingEnabled: selectors.payments.hasWhitelistingAddressesEnabled(state),
  step: selectors.whitelistAddress.getStep(state)
})

const mapDispatchToProps = (dispatch) => ({
  goToStep: (step) => {
    dispatch(actions.form.change(formName.WHITELIST_ADDRESS, 'step', step))
  },
  handleSubmit: (step) => {
    dispatch(actions.whitelistAddress.submit(step))
  },
  hideModal: (name) => {
    dispatch(actions.app.hideModal(name))
  },
  removeTotpConfig: () => {
    dispatch(actions.auth.removeTotpConfig())
  },
  resetForm: () => {
    dispatch(actions.form.reset(formName.WHITELIST_ADDRESS))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(WhitelistAddressContainer)
